import PropTypes from 'prop-types';
import StrikeThroughWrapper from 'components/containers/strikethrough-wrapper';

const TaskCreatorCell = ({ task }) => {
  if (!task) return null;

  const { completed_at, creator_info } = task;

  return (
    <StrikeThroughWrapper hasStrikeThrough={!!completed_at}>
      {creator_info ? <span className="fs-exclude-data">{creator_info.name}</span> : null}
    </StrikeThroughWrapper>
  );
};

TaskCreatorCell.propTypes = {
  task: PropTypes.object.isRequired,
};

export default TaskCreatorCell;
